
import { useSelector } from "react-redux";
import { DataGrid } from "../../../../../components";
import { getLocalized } from "../../../../../redux/localization";
import { createDocumentUrl, documentsUrl } from "../../../../../services/urls";
import { AccountDocument } from "../../../types";
import CreateDocumentForm from "./create";
import AccountDocumentDetailModal from "./detail";


const AccountDocumentPage = ({ id }: { id?: string }) => {
  const localize = useSelector(getLocalized);

  const columns = [
    {
      dataField: "AccountDocumentType",
      caption: localize.getString("accountdocumenttype"),
    },
    {
      dataField: "Approved",
      caption: localize.getString("approved"),
    },
    
    // {
    //   caption: localize.getString("approve"),
    //   type: "buttons",
    //   width: 110,
    //   buttons: [
    //     {
    //       hint: "Onayla",
    //       icon: "check",
    //       visible: (e: any) => !e.row.data.Approved,
    //       onClick: async (e: any) => {
    //         const response: ApiResponse = await createRequest({
    //           method: "POST",
    //           url: "api/admin/accounts/approve-document",
    //           bodyType: BodyType.raw,
    //           token,
    //           body: { documentId: e.row.data.Id },
    //           lang,
    //         });
    //         if (verfiyResponse(response)) {
    //           notify(response.Message, "success");
    //         } else notify(response.Message, "error");
    //       },
    //     },
    //   ],
    // },
  ];

  return (
    <DataGrid
      getByIdUrl={"/api/admin/accounts/get-document-detail"}
      url={"api/admin/accounts/get-account-documents/" + id}
      columns={columns || []}
      title={"Hesap Dökümanları"}
      refObject={
        {
          AccountDocumentType: "",
          AccountDocumentTypeId: 1,
          Approved: false,
          DocumentLocation: "",
          AccountId : id,
          AccountDocuments : [{}]
        } as AccountDocument
      }
      details={{
        width: "40%",
        height: "40%",
        getByIdUrl: "/api/admin/accounts/get-document-detail",
        title: localize.getString("brand-details"),
        component: AccountDocumentDetailModal,
      }}
      
      create={{
        width: "80%",
        height: "45%",
        createUrl: createDocumentUrl,
        title: localize.getString("addDocument"),
        component: CreateDocumentForm,
        validationGroup: "createdocumentFormValidation",
        lookup : {
          lookupUrl : documentsUrl
        }
      }}
    />
  );
};
export default AccountDocumentPage;
